import { memo, useEffect, useMemo, useState } from 'react'
import { timeFormat } from '../../NewSouscription/utils'

import { Chip, Button, Card, Alert, Tooltip } from '@mui/material'
import AddIcon from '@material-ui/icons/Add'
import PaymentIcon from '@material-ui/icons/Payment'
import allActions from '../../../redux/actions/user'
import { useDispatch } from 'react-redux'
import VisibilityIcon from '@material-ui/icons/Visibility';
import InfoIcon from '@material-ui/icons/Info'
import ReglementModalAppointment from '../create/ReglementModalAppointment';

const TENNIS = '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803'

export default memo(({ classes, setStep, panier, refreshBasketPrices, setFinalData }) => {
  const dispatch = useDispatch()
  const [reglementModal, setReglementModal] = useState(false)

  const [formatedActivities, setFormatedActivities] = useState(null)

  const passeportCarteData = useMemo(() => {
    const dict = {}
    for (let i in panier) {
      const item = panier[i]

      const openFixe = item.openFixe
      if (openFixe === 'Fixe' || item.activite.ACT_ID === TENNIS) continue

      const periode = item.periode.libelle
      const licencie = item.licencie.id
      const type_centre = item.centre.CNT_TYPECNT_ID

      const key = `${periode}-${licencie}-${type_centre}-${openFixe}`


      if (dict[key] === undefined) dict[key] = [item]
      else dict[key].push(item)
    }

    let valid = false
    let licencie = undefined
    let periode = undefined
    let centre = undefined
    let activities_libelles = []

    const activites_passeport = Object.values(dict).find(item => item.length >= 3)
    if (activites_passeport) {
      valid = true
      licencie = activites_passeport[0].licencie
      activities_libelles = activites_passeport.map(item => item.activite.ACT_LIBELLE).join(', ')
      periode = activites_passeport[0].periode
      centre = activites_passeport[0].centre
    }

    return {
      valid,
      activities: activites_passeport,
      activities_libelles,
      licencie,
      periode,
      centre,
    }
  }, [panier])

  useEffect(async () => {

    let newFormatedActivities = []

    if (passeportCarteData.valid) {

      const body = {
        licencie: passeportCarteData.licencie.id,
        periode: passeportCarteData.periode.prices.TAR_TYPEPER_ID,
        cnt_type: passeportCarteData.centre.CNT_TYPECNT_ID
      }
      let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/passeport-price/', body, dispatch)

      const carte_passeport = {
        passeport: true,
        centre: passeportCarteData.centre,
        licencie: passeportCarteData.licencie,
        price: data.TAR_MONTANT,
        periode: passeportCarteData.periode,

        // activité Pass dans la db
        activite: {
          ACT_ID: 'EFDA24CD-E6D9-4A18-8384-62E6FC446335',
          ACT_LIBELLE: 'Pass'
        }
      }

      newFormatedActivities = [carte_passeport, ...panier]
    } else {
      newFormatedActivities = panier
    }


    setFormatedActivities(newFormatedActivities)
    setFinalData({
      activite: newFormatedActivities.map(item => ({ ...item, isInPasseport: isInPasseport(item) })),
      total: getTotal(newFormatedActivities),
      passeportCarteData: passeportCarteData
    })
  }, [passeportCarteData])


  function isInPasseport(item) {
    return passeportCarteData.activities?.includes(item)
  }

  function getTotal(formatedActivities_) {
    if (!formatedActivities_) formatedActivities_ = formatedActivities
    if (!formatedActivities_) return null
    let total = 0
    for (const item of formatedActivities_) {
      if (item.passeport) total += item.price
      else if (!isInPasseport(item)) {
        total += item.periode.price
      }
    }
    return total
  }

  function addMoreActivity() {
    setStep(1)
    if (panier.length <= 0) {
      setStep(0)
    }
  }

  return (
    <>
      {/* Ne pas enlever (c'est pour le grid) */}
      <div></div>
      <Card variant="outlined" className={classes.panier}>
        {formatedActivities?.map((item, i) => (
          <div key={i}>
            {item.passeport ? (
              <div style={{ padding: '16px' }}>
                <div><b>
                  {item.centre.CNT_LIBELLE}: Carte passeport
                  <span style={{ fontSize: 20, color: 'rgb(0, 127, 255)' }}> {item.price}€</span>
                </b></div>
                <div>
                  <div style={{ marginBottom: 8 }}>Un {item.periode.libelle} (du {new Date(item.periode.dates.DATE_DEBUT).toLocaleDateString()} au {new Date(item.periode.dates.DATE_FIN).toLocaleDateString()})</div>
                  <div style={{ fontWeight: 'bold', color: 'red' }}>Licencie: {item.licencie.name}</div>
                </div>
              </div>
            ) : (
              <div style={{ padding: '16px' }}>
                <div><b>
                  {item.centre.CNT_LIBELLE}: {item.activite.ACT_LIBELLE}
                  <span style={{ fontSize: 20 }}>
                    {isInPasseport(item) ? (
                      <>
                        <span className={classes.barred}> {item.periode.price}€</span>
                        <span style={{ color: 'rgb(0, 127, 255)' }}> 0€</span>
                        <span style={{ fontSize: 14 }}> (carte passeport)</span>
                      </>
                    ) : (
                      <span style={{ color: 'rgb(0, 127, 255)', }}> {item.periode.price}€</span>
                    )}
                  </span>
                </b></div>
                <div>
                  {item.crenaux && <div>Le {item.crenaux.JOUR_LIBELLE} {timeFormat(item.crenaux.CO_HEUREDEBUT, item.crenaux.CO_HEUREFIN)}</div>}
                  <div style={{ marginBottom: 8 }}>Un {item.periode.libelle} (du {new Date(item.periode.dates.DATE_DEBUT).toLocaleDateString()} au {new Date(item.periode.dates.DATE_FIN).toLocaleDateString()})</div>
                  <div style={{ fontWeight: 'bold', color: 'red' }}>Licencie: {item.licencie.name}</div>
                  {item.category && <div>Pour {item.category.join(', ')}</div>}
                  {item.niveau && <div>Niveau: {item.niveau}</div>}
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <Chip label={item.openFixe} size="small" />
                    {item.periode.types?.length > 0 && <Chip label={item.periode.types.join(', ')} size="small" />}
                  </div>
                </div>
                <div>
                  <Button size="small" sx={{ marginTop: '8px' }} onClick={() => {
                    refreshBasketPrices(panier.filter((_, j) => j !== i))
                  }} className={classes.delete}>Supprimer</Button>
                </div>
              </div>
            )}
          </div>

        ))}
      </Card>


      <div style={{ flex: 'none' }}>
        <h2 style={{ marginBlock: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          Total: {getTotal()}€
          {passeportCarteData.valid && (<Tooltip placement="top" title={`Les activitées ${passeportCarteData.activities_libelles} donne droit à une carte passeport au licencié ${passeportCarteData.licencie.name}.`}>
            <InfoIcon color="primary" />
          </Tooltip>)}
        </h2>

        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          <Button
            onClick={() => addMoreActivity()}
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            sx={{
              textAlign: 'left',
              flex: 'none',
              width: 'calc(50% - 4px)'
            }}
          >
            Ajouter une autre activité
          </Button>
          <Button
            variant="contained"
            disableElevation
            startIcon={<VisibilityIcon />}
            fullWidth
            onClick={() => setReglementModal(true)}
            style={{
              flex: 'none',
              width: 'calc(50% - 4px)'
            }}
          >
            Pièce justificative
          </Button>
        </div>

        <ReglementModalAppointment setStep={setStep} setReglementModal={setReglementModal} reglementModal={reglementModal} />

      </div>
    </>
  )
})

